import { compose, layout, LayoutProps, MarginProps, space } from '@wrisk/styled-system'
import React, { AriaAttributes, FunctionComponent, useCallback } from 'react'
import styled from 'styled-components'

import { Input } from './Input'

export interface CheckboxProps
  extends MarginProps,
    LayoutProps,
    Pick<AriaAttributes, 'aria-labelledby'> {
  id?: string
  name?: string
  value?: boolean | undefined
  onChange?: (checked: boolean) => void
  className?: string
}

const Component: FunctionComponent<CheckboxProps> = ({
  id,
  name,
  value,
  onChange,
  'aria-labelledby': ariaLabelledby,
  ...props
}) => {
  const onInputChange = useCallback(() => onChange?.(!value), [value, onChange])

  return (
    <div {...props}>
      <Input
        name={name}
        id={id}
        type='checkbox'
        onChange={onInputChange}
        checked={value ?? false}
        data-testid='checkbox-input'
        aria-labelledby={ariaLabelledby}
      />
    </div>
  )
}

export const Checkbox = styled(Component)(
  {
    position: 'relative',
    width: '1.5rem',
    height: '1.5rem',
    minWidth: '1.5rem',
    minHeight: '1.5rem',
    input: {
      appearance: 'none',
      display: 'block',
      width: '100%',
      height: '100%',
      cursor: 'pointer',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100%',
    },
  },
  (props) => ({
    input: {
      backgroundImage: props.value
        ? `url('${props.theme.icons.checkboxOn.url}')`
        : `url('${props.theme.icons.checkboxOff.url}')`,
      '&:focus-visible': {
        outline: `2px solid ${props.theme.colors.focus}`,
      },
    },
  }),
  compose(space, layout),
)
